import { useContext } from 'react';
import { useUtcomApi } from '../../../hooks/useUtcomApi';
import { ModalContext, Modals } from '../../../modalsContext';

export interface FormValues {
  amount: number;
}

export const useSubmit = (currency: 'RUB' | 'USD') => {
  const utcomApi = useUtcomApi();
  const { setCurrentModalOpen } = useContext(ModalContext);

  return {
    onSubmit: async (values: FormValues) => {
      const response = await utcomApi.invoiceService.createInvoice({
        amount: {
          value: values.amount,
          currency,
        },
      });

      if (typeof window !== undefined) {
        setCurrentModalOpen(Modals.DOWNLOAD);
        window.open(response.data.invoiceUrl);
      }
    },
  };
};
